export const config = {
  debug: false,
  api: {
    baseUrl: "",
    sendMail: "/v1/sendmail",
    register: "/v1/user",
    newsletter: "/v1/newsletter"
  }
}